import { FC } from 'react';
import {
  EntitySearchTextFilter,
  EntityTagPicker,
  UserListPicker,
  WbResponsiveTableToolbar,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import { useEntityList } from '@mainstage/plugin-catalog-react';

export const BlueprintListFilters: FC = () => {
  const { filters, updateFilters } = useEntityList();
  const configApi = useApi(configApiRef);

  return (
    <WbResponsiveTableToolbar
      searchProps={{
        value: filters.text?.value,
        onChange: value => {
          updateFilters({ text: new EntitySearchTextFilter(value, configApi) });
        },
      }}
      onClear={() => {
        updateFilters({
          type: undefined,
          tags: undefined,
          user: undefined,
          text: undefined,
        });
      }}
      marginBottom
    >
      <WbResponsiveTableToolbar.Filters>
        <EntityTagPicker />
        <UserListPicker />
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
